import { createSlice } from '@reduxjs/toolkit'

export const professoEeditIDSlice = createSlice({
  name: 'professorEditID',
  initialState: {
    value: ''
  },
  reducers: {
    updateEditID: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { updateEditID } = professoEeditIDSlice.actions

export const selectEditID = (state) => state.professorEditID.value

export default professoEeditIDSlice.reducer